import SocketMessages from "../enums/SocketMessages";
import {SocketMessageReceiver} from "./SocketMessageReceiver";
import {reconnect} from "../api/methods/auth";
import { getBaseUrl } from "@api/helpers/url/baseUrl";
// import state from '../store/main/state'


export class SocketHelper {
    link = '/messenger/socket';

    messageReceiver = null;
    store = null;
    timerId = null;
    /**
     * Time before next try to reconnect
     * @type {number}
     */
    errorPauseTime = 0;
    connectionError = false;


    /**
     * @param store {Store}
     */
    constructor(store) {
        this.store = store;
        this.a = false;
        this.initPauseTime();
    }

    prepareUrl(url) {
        const parser = document.createElement("a");
        parser.href = url;
        return parser;
    }

    startHeartbeat() {
        this.timerId = setInterval(() => {
            this.sendMessage('ping', {});
        }, 30000);
    }

    stopHeartbeat() {
        clearInterval(this.timerId);
    }

    /**
     * @param session {Session}
     */
    connect(session) {
        let server = getBaseUrl(session.backend);
        if (server.match(new RegExp(/^(http:\/\/|https:\/\/)/)) == null) {
            server = window.location.origin + server;
        }

        const url = server.replace('http://', 'ws://')
                          .replace('https://', 'wss://');

        try {
            this.socket = new WebSocket(url + this.link + `?sessionId=${session.sessionId}&language=${session.language}`);
        }
        catch (e) {
            this.store.dispatch('reportException', e, {root: true});
            this.socketReconnect();
        }

        this.socket.onopen = (e) => {
            this.messageReceiver = new SocketMessageReceiver(this.socket,  this.store);
            this.startHeartbeat();
            this.initPauseTime();
        };

        this.socket.onerror = async function(error) {
            this.connectionError = true;
        };

        this.socket.onclose = (e) => {
            this.stopHeartbeat();
            this.socketReconnect();
        }
    }

    socketReconnect() {
        setTimeout(() => {
            this.incrementPauseTime();
            if (this.connectionError) {
                this.relogin()
                    .then((res) => {
                        this.connectionError = false;
                        if (res) {
                            this.connect(this.store.state.session);
                        }
                        else {
                            //@todo chat notification
                            this.store.dispatch('reportError', 'Не удалось подключиться к сокету, попробуйте перезагрузить страницу', {root: true});
                        }
                    })
            }
            else {
                this.connect(this.store.state.session);
            }
        }, this.errorPauseTime)
    }

    async relogin() {
        let result = true;
        try {
            await this.store.dispatch('relogin');
            //@todo session update
        }
        catch (e) {
            result = false;
        }
        return result;
    }

    initPauseTime() {
        this.errorPauseTime = 0;
    }

    incrementPauseTime() {
        if (this.errorPauseTime >= 300000) {
            return;
        }
        switch (this.errorPauseTime) {
            case 0:
                this.errorPauseTime = 5000;
                break;
            case 5000:
                this.errorPauseTime = 15000;
                break;
            case 15000:
                this.errorPauseTime = 30000;
                break;
            default:
                this.errorPauseTime += 30000;
        }
    }

    /**
     * @param type {string}
     * @param data {object}
     */
    sendMessage(type, data) {
        this.socket.send(JSON.stringify({
            "event": type,
            "data": data
        }));
    }

    openMessage(messageIDs) {
        this.sendMessage(SocketMessages.openMessage, {messageIDs});
    }

    sendTyping({roomId, type}) {
        this.sendMessage(SocketMessages.sendTyping, {
            roomId: roomId,
            type: type
        });
    }

    sendMessages({ roomID, message, localID, type, attachments}) {
        this.sendMessage(SocketMessages.sendMessage, {
            "roomID": roomID,
            "message": message,
            "localID": localID,
            "type": type,
            "attachments": attachments
        })
    }

}